import * as React from 'react';


import { CartSeat } from '../../../classes/seat';
import { tryCheckout } from '../../../cart/actions/cart-actions';
import { Dispatch } from 'redux';
import { Seat } from '../../../classes/seat';
import CartItems from './cart-items';
import { IAltText } from '../../../classes/alt-text';
import { ItemType } from '../../../classes/item-type';
import { SeatingOptionGroup } from '../../../classes/seating-option';
import { PriceType } from '../../../classes/price-type';
import isEqual from 'react-fast-compare';

export interface ICartProps {
    cartSeats: Array<CartSeat>;
    dispatch: any /*Dispatch<any>*/;
    itemId: number;
    itemType: ItemType;
    allowExchangesAddon: boolean;
    altText: IAltText;

    selectedAdditionalOptionGroups: Array<SeatingOptionGroup>; //used for non-seat bound seating options

    cartCheckoutButton: string;
    cartAddMoreButton: string;
    seatMapId: string;
    selectedSeatIds: string;
    allSeats: Array<Seat>;
    cartDisabled: boolean;
    cartMessage: string;

    //CartItems props
    cartSubtotalLabel: string;
    cartEmptyNotice: string;
    useZoneDescription: boolean;
    groupSeatCartItemText: string;
    currencyFormat: string;
    exchangeFreeLabel: string;
    brandId: string;
    additionalNotes: string;

    selectedPriceTypes: Array<PriceType>;
    hidePricesInCart: boolean;
    fetchSeatViewImage: boolean;

    displaySeatFee?: boolean;
    priceFeeHeading?: string;
}

interface ICartInteractionState {
    mobileCartOpen: boolean;
}

class Cart extends React.Component<ICartProps, ICartInteractionState>{
    constructor(props) {
        super(props);
        this.state = {
            mobileCartOpen: false,
        }
    }

    shouldComponentUpdate(nextProps: ICartProps, nextState) {
        return this.props.cartSeats.length != nextProps.cartSeats.length
            || this.props.cartDisabled != nextProps.cartDisabled
            || this.props.selectedSeatIds != nextProps.selectedSeatIds
            || this.props.additionalNotes != nextProps.additionalNotes
            || !isEqual(this.props.cartSeats.map(s => s.selectedPricing.priceTypeId), nextProps.cartSeats.map(s => s.selectedPricing.priceTypeId))
            || !isEqual({ optionGroups: this.props.selectedAdditionalOptionGroups, priceTypes: this.props.selectedPriceTypes },
                { optionGroups: nextProps.selectedAdditionalOptionGroups, priceTypes: nextProps.selectedPriceTypes });
    }

    render() {
        var cartContainerClass = 'cart-container';

        return (
            <div className={cartContainerClass} >
                    <div className="cart-mini-container">

                        <CartItems {...this.props} />

                    </div>
            </div>
        );
    }

}

export default Cart;